import Vue from 'vue'
import VueRouter from 'vue-router'
import Utils from './services/utils-service.js';
import Funnel from './services/funnel-service.js';
import PageComponent from './components/Page.js';
import AppComponent from './components/App.js';
import store from "./store.js";
import App from "./main.js";

Vue.use(VueRouter)

const router = new VueRouter({
    //mode: 'history',
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: [
        {
            path: '/content',
            name: 'content',
            beforeEnter() {
                const contentSite = site_url + '?bns=1&MDRefCode=' + mdrc;
                window.location.replace(contentSite);
            }
        },
        {
            path: '/',
            name: 'app',
            props: true,
            component: AppComponent,
            meta: {
                usePathAnalytics: true
            }
        },
        {
            path: '/:page',
            name: 'app-page',
            props: true,
            component: PageComponent,
            meta: {
                usePathAnalytics: true
            }
        },
        {
            path: '/:page/:pn1',
            name: 'app-pn1',
            props: true,
            component: PageComponent,
            meta: {
                usePathAnalytics: true
            }

        },
        {
            path: '/:page/:pn1/:pn2',
            name: 'app-pn2',
            props: true,
            component: PageComponent,
            meta: {
                usePathAnalytics: true,
            }
        },
        {
            path: '/:page/:pn1/:pn2/:pn3',
            name: 'app-pn3',
            props: true,
            component: PageComponent,
            meta: {
                usePathAnalytics: true
            }
        },
        {
            path: '/:page/:pn1/:pn2/:pn3/:pn4',
            name: 'app-pn4',
            props: true,
            component: PageComponent,
            meta: {
                usePathAnalytics: true
            }
        }
    ]
});

window.popStateDetected = false;

window.addEventListener('popstate', () => {
    window.popStateDetected = true;
});

router.beforeEach((to, from, next) => {
    const fs = new Funnel({ ctx: App.store, router: router });

    const isBrowserBckBtn =  window.popStateDetected;
    window.popStateDetected = false;
    if (isBrowserBckBtn) {
        next(false);
        fs.previous(fs.ctx.getters.active_page);
        return;
    } else {
        if (localStorage) {
            fs.removeZipOnBNSReq();
            if (to.query.pf) {
                return next();
            } else if (!localStorage.getItem('zipcode') && to.path !== "/zip-code") {
                return next("/zip-code");
            } else {
                if (to.path == "/") {
                    return next("/intro");
                }
                return next();
            }
        }
        next();
    }
});

router.afterEach((to, from) => {
    const fs = new Funnel({ ctx: App.store, router: router });
    //fs.testConsoleFxn('Hello afterEach');

    setTimeout(function () {
        store.commit('TRIGGER_ANALYTICS', true)
    }, 1500);

    const pageAnnouncer = document.getElementById('page-announcer');
    if (pageAnnouncer) {
        setTimeout(function () {
            console.log(to.meta.title,document.title , to.name, to.path);
            pageAnnouncer.textContent = `Navigated to ${to.meta.title || document.title || to.name || to.path}`;
        }, 500);
        
    }


    function loadChat() {
        setTimeout(function () {
            let loading = store.getters.loading.status,
                ctd = store.getters.factory.custom_template_data;
            if (loading || !ctd) {
                
                setTimeout(function () {
                    loadChat()
                }, 1000);
                return

            } else {
                console.log('check if chat exists: ', store.getters.factory.custom_template_data);
                if (!store.getters.factory.custom_template_data.enroll_chat) { return }

                let ctd_chat_data = store.getters.factory.custom_template_data.enroll_chat,
                    chat_routes = ctd_chat_data.pages,
                    toNoLOB = '/' + to.path.split("/").pop(),
                    fromNoLOB = '/' + from.path.split("/").pop();

                ctd_chat_data.template_set = store.getters.factory.template_set;

                console.log('chat routes loaded: ', chat_routes);
                if (chat_routes.indexOf(toNoLOB) == -1 && chat_routes.indexOf(fromNoLOB) == -1) {
                    console.log('no chat on chat_routes on this page or previous');
                    return
                }
                
                if (chat_routes.indexOf(toNoLOB) >= 0) {
                    console.log('load the chat--------------');
                    Funnel.chatIframe(ctd_chat_data, to.path);

                } else {
                    console.log('trigger remove chat');
                    Funnel.removeChats()
                }
            }
        }, 250)
    }

    loadChat();
});

export default router;

